<template>
  <div class="section container">
    <h1 class="title has-text-primary">{{ data.title }}</h1>
    <h2 class="subtitle has-text-black">{{ data.intro }}</h2>
  </div>
</template>
<script>
export default {
  name: "Head",
  props: ["data"],
  data() {
    return {
      title: "Head",
    };
  },
};
</script>
